import React from "react";
import PhotoPicker from "./PhotoPicker";
import { Overlay, Modal, Title, Comment, Info, ModalButtons, Button } from "./design";

const formatDate = (date) => {
    if (!date) return "";
    const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(String(date));
    return m ? `${m[3]}.${m[2]}.${m[1]}` : String(date);
};

const CompleteTaskModal = ({
    task, photos, saving, photoProcessing, onClose,
    onComplete, onPhotos, onOpenCamera, onRemovePhoto, onPreview
}) => {
    const busy = saving || photoProcessing;
    return (
        <Overlay onClick={() => { if (!busy) onClose(); }}>
            <Modal role="dialog" aria-modal="true" aria-label="Aufgabe erledigen" onClick={e => e.stopPropagation()}>
                <Title>Aufgabe erledigen</Title>
                <Comment style={{ marginTop: 15 }}>{task.comment}</Comment>
                <Info>{task.house} · {formatDate(task.date)}</Info>
                <PhotoPicker
                    label="Fotos nach der Arbeit"
                    photos={photos}
                    disabled={saving}
                    processing={photoProcessing}
                    onFiles={files => onPhotos(files, "completion")}
                    onCamera={() => onOpenCamera("completion")}
                    onRemove={index => onRemovePhoto("completion", index)}
                    onPreview={onPreview}
                />
                <ModalButtons>
                    <Button type="button" $secondary disabled={busy} onClick={onClose}>Abbrechen</Button>
                    <Button type="button" disabled={busy || !photos.length} onClick={onComplete}>
                        ✓ Als erledigt speichern
                    </Button>
                </ModalButtons>
            </Modal>
        </Overlay>
    );
};
export default CompleteTaskModal;
